import {Card, Box, Typography, Link} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {ChevronRight} from '@jobseeker/lotus/icons';
import {getReplacedString} from '@jobseeker/lotus/utils';
import {shallowEqual, useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {TrackEventUBA, getUbaPageName} from '@jobseeker/common-core/utils';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export default ({children, cardSxProps = {}, ...props}: CTAProps) => {
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);
  return (
    <Card
      sx={{
        borderRadius: 4,
        position: 'relative',
        ...cardSxProps,
      }}
    >
      {props.cardInfo?.map((info, index) => {
        const showDivider = props?.cardInfo?.length
          ? index < props?.cardInfo?.length - 1
          : false;

        const title = getReplacedString(
          info?.title || '',
          props?.valueToReplace || '',
          props?.dynamicValue || ''
        );

        return (
          <>
            <Box
              key={`lotus-CTA-v4-${index}`}
              data-testid={`lotus-cta-v4-${(info?.title || info?.subTitle)
                ?.toLowerCase()
                ?.replace(/ /g, '-')}`}
              p={2}
              sx={{
                borderBottom: showDivider
                  ? '1px solid rgba(126, 126, 126, 0.2)'
                  : '',
              }}
            >
              {info?.subTitle && (
                <Typography
                  fontSize={isAppIimjobs ? 10 : 13}
                  textTransform={'uppercase'}
                  color="text.secondary"
                  fontWeight="medium"
                >
                  {info.subTitle}
                </Typography>
              )}
              {title && (
                <Typography
                  fontSize={12}
                  fontWeight="medium"
                  sx={{wordWrap: 'break-word'}}
                >
                  {title}
                </Typography>
              )}
              <Link
                onClick={() => {
                  if (info?.subTitle === 'not finding relevant jobs?') {
                    TrackEventUBA('tagSelectionClick', 'click', {
                      categoryID: '',
                      tagID: '',
                      page: getUbaPageName(),
                      sessionUsername: sessionStorage.getItem('userId') || '',
                    });
                  }

                  if (title === 'My Learning Centre') {
                    TrackEventUBA('learningCentreClick', 'click', {
                      categoryID: '',
                      tagID: '',
                      page: getUbaPageName(),
                      sessionUsername: sessionStorage.getItem('userId') || '',
                    });
                  }
                }}
                href={info.actionUrl}
                target="_self"
                sx={{
                  textDecoration: 'none',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  mt: 0.25,
                }}
              >
                <Typography fontSize={12} color="primary" fontWeight="medium">
                  {info.actionLabel}
                </Typography>
                <Box component={'span'} sx={{mx: 0.25}}>
                  <Image
                    src={ChevronRight}
                    alt={'Arrow'}
                    width={10}
                    height={10}
                    objectFit="cover"
                  />
                </Box>
              </Link>
            </Box>
          </>
        );
      })}
    </Card>
  );
};
